import {uploadOss } from '@/api/common/commonFile';
import {ossDownload} from '@/api/common/commonFile';
import CryptoJS from 'crypto-js';
import SparkMD5 from 'spark-md5';
// const OSS = require('ali-oss');
// const path = require("path");

// const client = new OSS({
//   // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
//   region: 'yourRegion',
//   // 阿里云账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM用户进行API访问或日常运维，请登录RAM控制台创建RAM用户。
//   accessKeyId: 'yourAccessKeyId',
//   accessKeySecret: 'yourAccessKeySecret',
//   // 填写Bucket名称，例如examplebucket。
//   bucket: 'examplebucket',
// });
// 判断文件是否存在
export async function isExistObject(client, name, options = {}) {
  try {
      await client.head(name, options);
      console.log('文件存在')
   }  catch (error) {
      if (error.code === 'NoSuchKey') {
        console.log('文件不存在')
      }
   }
}
// 文件内容上传
export async function putBuffer (client, url, content) {
  try {
    const result = await client.put(url, new Buffer(content));
    console.log(result);
  } catch (e) {
    console.log(e);
  }
}
// const headers = {
//   // 指定该Object被下载时的网页缓存行为。
//   'Cache-Control': 'no-cache',
//   // 指定该Object被下载时的名称。
//   'Content-Disposition': 'example.txt',
//   // 指定该Object被下载时的内容编码格式。
//   'Content-Encoding': 'utf-8',
//   // 指定过期时间，单位为毫秒。
//   'Expires': '1000',
//   // 指定Object的存储类型。
//   'x-oss-storage-class': 'Standard',
//   // 指定Object标签，可同时设置多个标签。
//   'x-oss-tagging': 'Tag1=1&Tag2=2',
//   // 指定初始化分片上传时是否覆盖同名Object。此处设置为true，表示禁止覆盖同名Object。
//   'x-oss-forbid-overwrite': 'true'
// }
// 分片上传，断点记录
const progress = (p, _checkpoint) => {
  // Object的上传进度。
  console.log(p);
  // 分片上传的断点信息。
  console.log(_checkpoint);
};

// 开始分片上传。
export async function multipartUpload(client, url, file) {
  try {
    // 依次填写Object完整路径（例如exampledir/exampleobject.txt）和本地文件的完整路径（例如D:\\localpath\\examplefile.txt）。Object完整路径中不能包含Bucket名称。
    // 如果本地文件的完整路径中未指定本地路径（例如examplefile.txt），则默认从示例程序所属项目对应本地路径中上传文件。
    const result = await client.multipartUpload(url, file, {
      progress,
      // headers,
      // 指定meta参数，自定义Object的元信息。通过head接口可以获取到Object的meta数据。
      meta: {
        year: 2020,
        people: 'test',
      },
    });
    console.log(result);
    // 填写Object完整路径，例如exampledir/exampleobject.txt。Object完整路径中不能包含Bucket名称。
    return await client.head(url);
  } catch (e) {
    // 捕获超时异常。
    if (e.code === 'ConnectionTimeoutError') {
      console.log('TimeoutError');
      // do ConnectionTimeoutError operation
    }
    console.log(e);
    return {
      status: 300
    };
  }
}
export function sparkMd5(file){
  return new Promise(resolve=>{
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = function(e) {
      const md5 = SparkMD5.ArrayBuffer.hash(e.target.result);
      resolve(md5);
    };
  })
} 
export async function uploadFile(file) {
  let data = null;
  if (file) {
    // const md5 = await calculateFileMD5(file); // 等待计算文件的MD5哈希值
    const md5=await sparkMd5(file);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('md5', md5);
    const res = await uploadOss(formData); // 等待上传到OSS
    if (res.code === 200) {
      data = res.data;
    }
  }
  return data;
}
export function calculateFileMD5(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = function(event) {
      const arrayBuffer = event.target.result;
      const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
      const md5 = CryptoJS.MD5(wordArray).toString();
      resolve(md5);
    };
    reader.onerror = function() {
      reject(new Error('Failed to read file.'));
    };
  });
}
/**OSS文件下载 */
export function ossFileDownload(id){
  ossDownload(id).then(res=>{
    if(res.data){
      var bolb=new Blob([res.data],{type:'application/octet-stream'});
      var url=URL.createObjectURL(bolb);
      var link=document.createElement('a');
      link.href=url;
      link.download=decodeURIComponent(res.headers['file-name']);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  })
}
